import { render, staticRenderFns } from "./TabelaOrcamento.vue?vue&type=template&id=3bbfd908&"
import script from "./TabelaOrcamento.vue?vue&type=script&lang=js&"
export * from "./TabelaOrcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports